// extracted by mini-css-extract-plugin
module.exports = {"customModal":"_requestAccess_customModal__5cqPq","formDescription":"_requestAccess_formDescription__05yJy","horizontal":"_requestAccess_horizontal__x4i4c"};